"use strict";

import { List } from "immutable";
import _ from "lodash";

import AppConstants from "../constants/AppConstants.js";
import BlockConverter from "../utils/BlockConverter.js";
import BlockContainer from "./BlockContainer";

class SitePage extends BlockContainer {
  constructor(/** Immutable **/ pageData, /** SiteDesign **/ design) {
    super(pageData);

    this.design = design;
  }

  /**
   * Convert a site canvas block to page block
   * @param {string} blockId - ID of the block to convert
   * @param {import("./SiteDesign").default} siteDesign - The site design containing the original site blocks
   * @returns {Immutable.Map} The converted block
   */
  convertToPageBlock(blockId, siteDesign) {
    var block = this.getBlock(blockId);
    if (block) {
      var siteBlock = siteDesign.getBlock(block.get(AppConstants.BLOCK_PROP_PARENT_BLOCK_ID));

      if (siteBlock) {
        var blockJS = block.toJS();
        var siteBlockJS = siteBlock.toJS();

        var pageBlock = BlockConverter.toPageBlock(blockJS, siteBlockJS);

        block = this.overwriteBlock(blockId, pageBlock);
      }
    }

    return block;
  }

  applyUpdate(/** vo/PageUpdate **/ pageUpdate) {
    var updatePageId = pageUpdate.id;
    var updates = pageUpdate.updates;

    var pageId = this.data.get("id");
    if (pageId != updatePageId) {
      return;
    }

    var page = this.data;

    var updatedPage = page.withMutations(function (pg) {
      updates.forEach(function (update) {
        if (_.isObject(update.value) && !List.isList(update.value)) {
          pg.mergeIn(update.key, update.value);
        } else {
          if (_.isEmpty(update.value) && !_.isNumber(update.value)) {
            pg.deleteIn(update.key);
          } else {
            pg.setIn(update.key, update.value);
          }
        }
      });

      return pg;
    });

    this.data = updatedPage;
  }

  get slug() {
    return this.data.get("slug");
  }
}

export default SitePage;
